/**
 * Create a random id.
 *
 * @param  {number} [l] The length of the id. Default is 13.
 * @returns {string} The random id.
 */
export function randomID(l = 13) {
    return ("id_" +
        Math.random()
            .toString(36)
            .substring(2, 2 + l));
    //  + Math.random().toString(36).substring(2, 15);
}
/**
 * Wait for a condition to be true.
 *
 * @param {() => boolean} conditionFunc     The function that returns the
 *                                          condition.
 * @param {number}        [checkFrequency]  The frequency to check the
 *                                          condition. Default is 100.
 * @param {number}        [timeout]         The maximum time to wait in ms. If
 *                                          0, waits indefinitely. Default is 0.
 * @returns {Promise<void>}  A promise that resolves when the condition is true,
 *  or rejects if it times out.
 */
export function waitForCondition(conditionFunc, checkFrequency = 100, timeout = 0) {
    return new Promise((resolve, reject) => {
        // Perform an immediate check
        if (conditionFunc()) {
            resolve();
            return;
        }
        // If the condition is not met, set up the interval for subsequent checks
        const interval = setInterval(() => {
            if (conditionFunc()) {
                clearInterval(interval);
                if (timeoutId)
                    clearTimeout(timeoutId);
                resolve();
            }
        }, checkFrequency);
        let timeoutId = null;
        if (timeout > 0) {
            timeoutId = window.setTimeout(() => {
                clearInterval(interval);
                reject(new Error(`waitForCondition timed out after ${timeout}ms`));
            }, timeout);
        }
    });
}
